import React from 'react';
import ReactDOM from 'react-dom';
import {AreaDispatcher} from '../../../../hooks/useAreas';
import WritableAreaPopup from './WritableAreaPopup';
import NonWritableAreaPopup from './NonWritableAreaPopup';

export interface AreaPopupProps {
    areaLocalId: string;
    areas: Record<string, Area>;
    areaDispatcher: AreaDispatcher;
    onPopupChange: (popup: MapPopup) => void;
}

export default function AreaPopup(props: AreaPopupProps) {
    const {areas, areaLocalId} = props;
    const area = areas[areaLocalId];

    if (area.properties.writable) {
        return <WritableAreaPopup {...props} />;
    } else {
        return <NonWritableAreaPopup {...props} />;
    }
}
